import { api, apiN8N } from "./api-core";

export interface IUserRoundStatus {
  code: string;
  status: string;
  competition: {
    id: number,
    name: string,
    short_desc: string,
    description: string,
    start_date: string,
    end_date: string,
    status: number,
    created_at: string,
    updated_at: string
  }
  rounds: {
    id: number;
    competition_id: number;
    round_number: number;
    round_name: string;
    description: string;
    due_date: string;
    status: number;
    created_at: string;
    updated_at: string;
  }[];
  round_parts: {
    part_id: number;
    part_number: number;
    part_name: string;
    title: string;
    description: string;
    due_date: string;
    status: number;
    completed_at: string;
    submission_data: string;
  }[];
  ai_usage: {
    used_count: number,
    max_limit: number
  }
}

export interface IListSubmissionTcc {
  code: number;
  message: string;
  data: {
    total: number;
    data: ISubmission[];
    top_users: {
      user: string;
      display_name? : string;
      score: number | null;
    }[]
  };
}

export interface ISubmissionTcc {
  code: number;
  message: string;
  data: {
    total: number;
    data: ISubmission;
  };
}

export interface ISubmission {
  user: string;
  submitted_count: number;
  score: number | null;
  ai_score: number | null;
  ai_score_data: object;
  judge: {
    judge: string,
    score: number,
    feedback: string,
    ai_score: number,
    ai_score_data: string,
    display_name: string
  };
  judgeInfo: {
    judge: string,
    score: number,
    feedback: string,
    ai_score: number,
    ai_score_data: string,
    display_name: string
  };
  total_parts: number;
  submissions: ISubmissionDetail[];
  display_name? : string;
  assigned_judge?: string;
}

export interface ISubmissionDetail {
  round_part_id: number;
  section: string;
  content: IContent;
}

export interface IContent {
  problem?: string;
  schoolType?: string;
  location?: string;
  studentPopulation?: string;
  teacherCount?: string;
  techResources?: string;
  keyChallenges?: string;
  additionalContext?: string;
  aiPrompt?: string;
  aiEngine?: string;
  finalProposal?: string;
  aiTool?: string;
  strengths?: string;
  weaknesses?: string;
  feasibility?: string;
  ethics?: string;
  implementationSteps?: string;
  resourcesNeeded?: string;
  expectedOutcomes?: string;
}

export interface IJudges {
  code: number;
  status: string;
  data: {
    id: string;
    username: string;
    display_name: string;
    key: string;
    value: string;
  }[];
}

export interface IParticipants {
  data: {
    ID: string;
    user_login: string;
    user_pass: string;
    user_nicename: string;
    user_email: string;
    user_url: string;
    user_registered: string;
    user_activation_key: string;
    display_name: string;
    countryName: string;
    status: string;
    latest_submission_at: string;
    created_at: string;
  }[];
  count: number;
}

export const TCCApi = {
  getUserRoundStatus: () => {
    var url = process.env.API_GET_USER_ROUND_STATUS;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getListSubmissionTcc: (page?: any, per_page?: any, judge?: any) => {
    var url = process.env.API_GET_LIST_SUBMISSIONS + '?page=' + page + '&per_page=' + per_page + '&judge=' + judge;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  postStep: (data: {
    step: number;
    user: string;
    round_part_id: number;
    submission_data: string;
    status: number;
    part?: string;
  }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_STORE_SUBMISSION;

    return apiN8N
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  generateAi: (data: {
    problem: string;
    school_type: string;
    student_population: string;
    location: string;
    ai_engine: string;
    teacher_count: string;
    key_challenge: string;
    tech_resources: string;
    additional_context?: string;
    user: string;
    step: number;
    prompt?: string;
  }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_STORE_SUBMISSION;

    return apiN8N
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  saveGrade: (data: {
    judge: string;
    user: string;
    score: number;
    feedback: string;
  }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_SAVE_GRADE;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  getJudges: () => {
    var url = process.env.API_GET_DATA_JUDGE;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getParticipants: (page?: any, per_page?: any, searchTerm?: string, orderBy?: string, orderDirection?: string) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (per_page) params.append("per_page", per_page);
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (orderBy) params.append("orderBy", orderBy);
    if (orderDirection) params.append("orderDirection", orderDirection);

    const url = `${process.env.API_GET_PARTICIPANTS}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getUserWithNoSubmission: (page?: any, per_page?: any) => {
    var url = process.env.API_GET_USER_WITH_NO_SUBMISSION + '?page=' + page + '&per_page=' + per_page;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getUserWithAiScore: (page?: any, per_page?: any, searchTerm?:string, orderBy?: string, orderDirection?: string) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (per_page) params.append("per_page", per_page);
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (orderBy) params.append("orderBy", orderBy);
    if (orderDirection) params.append("orderDirection", orderDirection);

    const url = `${process.env.API_GET_USER_WITH_AI_SCORE}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  sendMailAlert: (data: {
    subject: string;
    message: string;
  })=>{
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_SEND_MAIL_TO_PARTICIPANTS;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  updateSiteAlert: (data: {
    message: any;
    is_active: any;
  }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_UPDATE_SITE_ALERT;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  getSiteAlert: () => {
    var url = process.env.API_GET_SITE_ALERT;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
};
